import { VFC, useMemo } from 'react';
import { ElectricityDeviceCategory } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { Select } from '../../Select';
import { deviceCategoryTranslated } from '../../../Form/meter_details/constants';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface ElectricityDeviceCategorySelectProps {
  value?: ElectricityDeviceCategory;
  onChange?: (value: ElectricityDeviceCategory) => void;
}

export const ElectricityDeviceCategorySelect: VFC<ElectricityDeviceCategorySelectProps> = ({
  ...restProps
}: ElectricityDeviceCategorySelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const deviceCategoryOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(ElectricityDeviceCategory),
        suggestedValue: meterModelSuggestions?.deviceCategory?.value,
        suggestedSelection: meterModelSuggestions?.deviceCategory?.selection,
        labelFormatter: (value: ElectricityDeviceCategory) => intl.formatMessage(deviceCategoryTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={deviceCategoryOptions}
      placeholder={<FormattedMessage {...messages.selectDeviceType} />}
      {...restProps}
    />
  );
};
